<template>
  <div class="ai-warp">
    <div class="header-warp">
      <header class="layoutMaxWidth">
       <h2>线上充值、手机点单</h2>
       <h2>各种增值服务！</h2>
      <p>手机微信端会员中心提供线上线下一体化服务</p>
        <img src="@/assets/img/wechat/wechat.png" alt />
      </header>
    </div>

    <main>
      <title>微信会员中心</title>
      <ul class="layoutMaxWidth">
        <li>
          <img src="@/assets/img/wechat/a1.png" alt />
         <h2>在线充值</h2>
          <p>电子账户和卡账户联通，实现在线自助充值，实时账户余额查询，消费账单查询，在线挂失</p>
        </li>
        <li>
          <img src="@/assets/img/wechat/a2.png" alt />
          <h2>扫码消费</h2>
          <p>会员中心设电子会员码，忘了带卡也可以扫码支付</p>
        </li>
        <li>
          <img src="@/assets/img/wechat/a3.png" alt />
          <h2>互动沟通功能</h2>
          <p>提供在线投诉、满意度调查、在线留言、食堂公告、最新菜谱，最新活动等互动信息</p>
        </li>
        <li>
          <img src="@/assets/img/wechat/a4.png" alt />
          <h2>增值业务功能</h2>
          <p>针对食堂场景等订餐、点单功能；提供商城等增值创收功能；提供营销和宣传板块</p>
        </li>
      </ul>
    </main>
  </div>
</template>
<script>
export default {
  name: "ai",
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/_variable.scss";
.ai-warp {
  .header-warp {
    background: url("~@/assets/img/ai/bg1@2x.png") center center no-repeat;
    box-sizing: 100% 100%;
    height: 385px;
  }
  header {
    display: block;
    font-style: italic;
    position: relative;
    h2 {
      padding-top: 99px;
      font-size: 54px;
      padding-bottom: 34px;
      font-weight: 700;
    }
    h2:nth-of-type(2){
      padding-top: 10px;
    }
    p {
      letter-spacing: 4px;
      font-size: 20px /*px*/;
      font-weight: 700;
    }
    img {
      position: absolute;
      top: 51px;
      right: 0;
      width: 144px;
    }
  }
  main {
    background: url("~@/assets/img/ai/bg@2x.png") top left no-repeat;
    background-size: 100% 100%;
    // width: 100%;
    height: 756px;
    title {
      display: inline-block;
      width: 100%;
      font-size: 21px /*px*/;
      font-weight: 500;
      text-align: center;
      line-height: 40px;
      color: white;
      padding-top: 89px;
    }
    title::after,
    title::before {
      display: inline-block;
      content: "";
      width: 64px;
      height: 1px;
      background-color: #9c9fa1;
      vertical-align: middle;
      margin-right: 16px;
    }
    title::after {
      margin-right: 0px;
      margin-left: 16px;
    }
    ul {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 61px;
      li {
        background-color: white;
        padding: 49px 38px 0;
        margin-right: 17px;
        margin-top: 2%;
        width: 48.95%;
        height: 229px;
        box-sizing: border-box;
        img {
          width: 48px;
        }
        h2 {
          font-size: 16px;
          color: $primary-color;
          margin-top: 28px;
        }
        p {
          margin-top: 4px;
          font-size: 11px;
          line-height: 1.5em;
        }
      }
      li:nth-child(2n) {
        margin-right: 0px;
      }
      li:last-child{
        img{
          width: 46px;
        }
      }
    }
  }
}
</style>